import type { ReactNode } from 'react';
import { Logo } from '@/components/brand/Logo';

export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  // Explicitly `| undefined`: callers pass a conditionally-computed subtitle straight
  // through, which exactOptionalPropertyTypes separates from omitting the prop.
  subtitle?: string | undefined;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="aurora-bg flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-md animate-fade-in-up">
        <div className="mb-6 flex flex-col items-center text-center">
          <Logo size={52} />
          <h1 className="mt-4 text-xl font-semibold tracking-tight">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
        </div>

        <div className="glass rounded-lg p-6 shadow-glow">{children}</div>

        {footer && <div className="mt-4 text-center text-sm text-muted-foreground">{footer}</div>}
      </div>
    </div>
  );
}
